/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';

export const StoreStatus = {
    "new": {
        name: "New",
    },
    "initial-load": {
        name: "Loading",
    },
    "failed": {
        name: "Failed",
    },
    "unloaded": {
        name: "Not loaded",
    },
    "done": {
        name: "Ready",
    }
};

export default declareEntity({
    entity: "storeInfos",
    graphQL: "StoreInfo",
    name: "Store Info",
    dynamoPrefix: 'sys',
    storageType: 'silo',
    userEditable: false,
    fields: (types) => { return {
        id: {
            name: "Store Info ID",
            type: "id",
            id: true,
            defaultValue: () => {
                return uuidv4();
            },
            required: true,
            primaryKey: true,
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            required: true
        },
        channelEntityDef: {
            name: "Application Entity Definition",
            type: "relation",
            to: () => types['channelEntityDefs'],
            defaultValue: (channelEntityDef) => {
                return channelEntityDef['id'];
            },
            required: true
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            defaultValue: (channelEntityDef) => {
                return channelEntityDef['channelDef_id'];
            },
            required: true
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            required: true
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        hasAnyData: {
            name: "Has any data?",
            type: "boolean",
            defaultValue: false,
        },
        status: {
            name: "Status",
            type: "enum",
            defaultValue: "new",
            values: StoreStatus
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; }
});
